import createIcon from '../../createIcon';

/**
 * @component @name Call
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMDEgMTUuMzhDMTguNzggMTUuMzggMTcuNTkgMTUuMTggMTYuNDggMTQuODJDMTYuMTMgMTQuNyAxNS43NCAxNC43OSAxNS40NyAxNS4wNkwxMy45IDE3LjAzQzExLjA3IDE1LjY4IDguNDIgMTMuMTMgNy4wMSAxMC4yTDguOTYgOC41NEM5LjIzIDguMjYgOS4zMSA3Ljg3IDkuMiA3LjUyQzguODMgNi40MSA4LjY0IDUuMjIgOC42NCAzLjk5QzguNjQgMy40NSA4LjE5IDMgNy42NSAzSDQuMTlDMy42NSAzIDMgMy4yNCAzIDMuOTlDMyAxMy4yOCAxMC43MyAyMSAyMC4wMSAyMUMyMC43MiAyMSAyMSAyMC4zNyAyMSAxOS44MlYxNi4zN0MyMSAxNS44MyAyMC41NSAxNS4zOCAyMC4wMSAxNS4zOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Call = createIcon('Call', [
  [
    'path',
    {
      d: 'M20.01 15.38C18.78 15.38 17.59 15.18 16.48 14.82C16.13 14.7 15.74 14.79 15.47 15.06L13.9 17.03C11.07 15.68 8.42 13.13 7.01 10.2L8.96 8.54C9.23 8.26 9.31 7.87 9.2 7.52C8.83 6.41 8.64 5.22 8.64 3.99C8.64 3.45 8.19 3 7.65 3H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21C20.72 21 21 20.37 21 19.82V16.37C21 15.83 20.55 15.38 20.01 15.38Z',
      key: 't2cedr',
    },
  ],
]);

export default Call;
